var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"modals":_vm.modals,"header":_vm.header,"methods":_vm.methods,"config":_vm.config}})}
var staticRenderFns = []

export { render, staticRenderFns }